// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PatientIntakeForm.css */

.patient-intake-form {
    margin: 2rem;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    font-family: 'Segoe UI', sans-serif;
    border: 3px solid var(--clr-primary-3);
  }
  
  .patient-intake-form h2 {
    text-align: center;
    margin-bottom: 2rem;
    color: #1e1e1e;
    font-size: 2.25rem;
  }
  
  .intake-section-intake-form {
    margin-bottom: 2.5rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 1.75rem;
    background-color: #f9f9f9;
  }
  
  .intake-legend {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.25rem;
  }
  
  .form-group-intake {
    margin-bottom: 1rem;
  }
  
  .two-column-intake,
  .three-column-intake {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .two-column-intake .input-intake-form,
  .two-column-intake .textarea-intake-form,
  .three-column-intake .input-intake-form {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 1rem);
  }
  
  .three-column-intake .input-intake-form {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 1rem);
  }
  
  .input-intake-form,
  .textarea-intake-form,
  select.input-intake-form {
    width: 100%;
    padding: 0.7rem 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 0.95rem;
    background-color: #fff;
    color: #222;
    transition: border-color 0.3s;
  }
  
  .input-intake-form:focus,
  .textarea-intake-form:focus,
  select.input-intake-form:focus {
    border-color: #0077cc;
    outline: none;
  }
  
  .textarea-intake-form {
    /* min-height: 100px; */
    resize: vertical;
  }
  
  .signature-input-intake {
    font-style: italic;
  }
  
  /* button[type="submit"] {
    display: block;
    width: max-content;
    padding: 0.85rem 2rem;
    background-color: #0077cc;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin: 2rem auto 0 auto;
  }
  
  button[type="submit"]:hover {
    background-color: #005fa3;
  } */
  
  /* Radio Group Custom Styling */
  .radio-grid-intake-form {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .radio-group-intake-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 0.6rem 1rem;
    /* gap: 1rem; */
    background-color: #fff;
    min-width: 280px;
  }
  
  
  .radio-label-intake-form {
    font-weight: 600;
    color: #444;
    margin-right: 1rem;
    min-width: 130px;
  }
  
  .radio-option-intake-form {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.95rem;
  }
  
  .radio-option-intake-form input[type="radio"] {
    transform: scale(1.1);
    cursor: pointer;
  }
  
  /* Responsive Styles */
  @media (max-width: 768px) {
    .two-column-intake .input-intake-form,
    .three-column-intake .input-intake-form {
      flex: 1 1 100%;
    }
  
    .patient-intake-form {
      padding: 1.25rem;
    }
  
    .radio-option-intake-form {
      flex-wrap: wrap;
      margin-bottom: 0.25rem;
    }
  
    .radio-grid-intake-form {
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
  
    .radio-group-intake-form {
      /* flex-direction: column; */
      align-items: flex-start;
    }
  }
  
  @media (max-width: 480px) {
    .patient-intake-form h2 {
      font-size: 1.5rem;
    }
  
    .radio-label-intake-form {
      font-size: 0.95rem;
    }
  
    .radio-option-intake-form {
      font-size: 0.9rem;
    }
  }
  
  .date-dual-row-intake {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .date-dual-row-intake .date-field-wrapper-intake {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 1rem);
    display: flex;
    flex-direction: column;
  }
  
  .date-inline-label-intake {
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
    color: #555;
    font-weight: 500;
  }
  
  .date-field-wrapper-intake {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .date-inline-label-intake {
    font-size: 0.85rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
    color: #333;
  }
  
  .intake-no-appointment-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 75vh;
    padding: 2rem;
    background-color: var(--clr-background);
  }
  
  .intake-info-card {
    background-color: var(--clr-white);
    border: 1px solid var(--clr-primary-8);
    border-left: 5px solid var(--clr-primary-5);
    border-radius: var(--radius);
    padding: 2rem 2.5rem;
    max-width: 700px;
    width: 100%;
    box-shadow: var(--shadow-2);
    text-align: left;
    font-family: var(--ff-secondary);
    color: var(--clr-grey-2);
  }
  
  .intake-info-heading {
    font-size: 1.75rem;
    margin-bottom: 1rem;
    color: var(--clr-primary-3);
  }
  
  .intake-info-text {
    font-size: 1rem;
    line-height: 1.7;
    margin-bottom: 1rem;
    color: var(--clr-grey-4);
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .intake-info-card {
      padding: 1.5rem;
    }
  
    .intake-info-heading {
      font-size: 1.5rem;
    }
  
    .intake-info-text {
      font-size: 0.95rem;
    }
  }
  

  .intake-radio-legend-horizontal {
    background-color: var(--red-light);
    border-left: 5px solid var(--red-dark);
    padding: 1rem 1.5rem;
    margin: 1.5rem 0;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    max-width: fit-content;
  }
  
  .legend-title-horizontal {
    font-size: 1rem;
    font-weight: 600;
    color: var(--clr-grey-1);
    margin-bottom: 0.5rem;
  }
  
  .legend-items-horizontal {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
  }
  
  .legend-item {
    font-size: 0.95rem;
    color: var(--clr-grey-1);
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }
  
  .legend-label {
    color: var(--clr-grey-1);
    font-weight: bold;
    font-size: 1rem;
    background-color: var(--clr-white);
    padding: 0.2rem 0.6rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
  }
  
  .mandatory-asterisk {
    color: red;
    margin-left: 4px;
  }
  
  .legend-horizontal-box {
    border: 1px solid var(--clr-grey-3);
    border-radius: 8px;
    padding: 0.75rem 1rem;
    background-color: var(--red-light);
    display: inline-block;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/components/IntakeForm/PatientIntakeForm.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;IACnC,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;;;IAGE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;;EAEA;;;IAGE,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;;;IAGE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;;;;;;;;;;;;;KAiBG;;EAEH,+BAA+B;EAC/B;IACE,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;;MAEE,cAAc;IAChB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,sBAAsB;IACxB;;IAEA;MACE,2DAA2D;IAC7D;;IAEA;MACE,4BAA4B;MAC5B,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uCAAuC;EACzC;;EAEA;IACE,kCAAkC;IAClC,sCAAsC;IACtC,2CAA2C;IAC3C,4BAA4B;IAC5B,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA,eAAe;EACf;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;;;EAGA;IACE,kCAAkC;IAClC,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;IAClB,qBAAqB;IACrB,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;EACvB","sourcesContent":["/* PatientIntakeForm.css */\n\n.patient-intake-form {\n    margin: 2rem;\n    padding: 20px;\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n    font-family: 'Segoe UI', sans-serif;\n    border: 3px solid var(--clr-primary-3);\n  }\n  \n  .patient-intake-form h2 {\n    text-align: center;\n    margin-bottom: 2rem;\n    color: #1e1e1e;\n    font-size: 2.25rem;\n  }\n  \n  .intake-section-intake-form {\n    margin-bottom: 2.5rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 1.75rem;\n    background-color: #f9f9f9;\n  }\n  \n  .intake-legend {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 1.25rem;\n  }\n  \n  .form-group-intake {\n    margin-bottom: 1rem;\n  }\n  \n  .two-column-intake,\n  .three-column-intake {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .two-column-intake .input-intake-form,\n  .two-column-intake .textarea-intake-form,\n  .three-column-intake .input-intake-form {\n    flex: 1 1 calc(50% - 1rem);\n  }\n  \n  .three-column-intake .input-intake-form {\n    flex: 1 1 calc(33.33% - 1rem);\n  }\n  \n  .input-intake-form,\n  .textarea-intake-form,\n  select.input-intake-form {\n    width: 100%;\n    padding: 0.7rem 1rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 0.95rem;\n    background-color: #fff;\n    color: #222;\n    transition: border-color 0.3s;\n  }\n  \n  .input-intake-form:focus,\n  .textarea-intake-form:focus,\n  select.input-intake-form:focus {\n    border-color: #0077cc;\n    outline: none;\n  }\n  \n  .textarea-intake-form {\n    /* min-height: 100px; */\n    resize: vertical;\n  }\n  \n  .signature-input-intake {\n    font-style: italic;\n  }\n  \n  /* button[type=\"submit\"] {\n    display: block;\n    width: max-content;\n    padding: 0.85rem 2rem;\n    background-color: #0077cc;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    font-size: 1rem;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin: 2rem auto 0 auto;\n  }\n  \n  button[type=\"submit\"]:hover {\n    background-color: #005fa3;\n  } */\n  \n  /* Radio Group Custom Styling */\n  .radio-grid-intake-form {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .radio-group-intake-form {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    padding: 0.6rem 1rem;\n    /* gap: 1rem; */\n    background-color: #fff;\n    min-width: 280px;\n  }\n  \n  \n  .radio-label-intake-form {\n    font-weight: 600;\n    color: #444;\n    margin-right: 1rem;\n    min-width: 130px;\n  }\n  \n  .radio-option-intake-form {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.95rem;\n  }\n  \n  .radio-option-intake-form input[type=\"radio\"] {\n    transform: scale(1.1);\n    cursor: pointer;\n  }\n  \n  /* Responsive Styles */\n  @media (max-width: 768px) {\n    .two-column-intake .input-intake-form,\n    .three-column-intake .input-intake-form {\n      flex: 1 1 100%;\n    }\n  \n    .patient-intake-form {\n      padding: 1.25rem;\n    }\n  \n    .radio-option-intake-form {\n      flex-wrap: wrap;\n      margin-bottom: 0.25rem;\n    }\n  \n    .radio-grid-intake-form {\n      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));\n    }\n  \n    .radio-group-intake-form {\n      /* flex-direction: column; */\n      align-items: flex-start;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .patient-intake-form h2 {\n      font-size: 1.5rem;\n    }\n  \n    .radio-label-intake-form {\n      font-size: 0.95rem;\n    }\n  \n    .radio-option-intake-form {\n      font-size: 0.9rem;\n    }\n  }\n  \n  .date-dual-row-intake {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .date-dual-row-intake .date-field-wrapper-intake {\n    flex: 1 1 calc(50% - 1rem);\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .date-inline-label-intake {\n    font-size: 0.85rem;\n    margin-bottom: 0.25rem;\n    color: #555;\n    font-weight: 500;\n  }\n  \n  .date-field-wrapper-intake {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .date-inline-label-intake {\n    font-size: 0.85rem;\n    font-weight: 500;\n    margin-bottom: 0.25rem;\n    color: #333;\n  }\n  \n  .intake-no-appointment-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 75vh;\n    padding: 2rem;\n    background-color: var(--clr-background);\n  }\n  \n  .intake-info-card {\n    background-color: var(--clr-white);\n    border: 1px solid var(--clr-primary-8);\n    border-left: 5px solid var(--clr-primary-5);\n    border-radius: var(--radius);\n    padding: 2rem 2.5rem;\n    max-width: 700px;\n    width: 100%;\n    box-shadow: var(--shadow-2);\n    text-align: left;\n    font-family: var(--ff-secondary);\n    color: var(--clr-grey-2);\n  }\n  \n  .intake-info-heading {\n    font-size: 1.75rem;\n    margin-bottom: 1rem;\n    color: var(--clr-primary-3);\n  }\n  \n  .intake-info-text {\n    font-size: 1rem;\n    line-height: 1.7;\n    margin-bottom: 1rem;\n    color: var(--clr-grey-4);\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .intake-info-card {\n      padding: 1.5rem;\n    }\n  \n    .intake-info-heading {\n      font-size: 1.5rem;\n    }\n  \n    .intake-info-text {\n      font-size: 0.95rem;\n    }\n  }\n  \n\n  .intake-radio-legend-horizontal {\n    background-color: var(--red-light);\n    border-left: 5px solid var(--red-dark);\n    padding: 1rem 1.5rem;\n    margin: 1.5rem 0;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    max-width: fit-content;\n  }\n  \n  .legend-title-horizontal {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--clr-grey-1);\n    margin-bottom: 0.5rem;\n  }\n  \n  .legend-items-horizontal {\n    display: flex;\n    gap: 2rem;\n    flex-wrap: wrap;\n  }\n  \n  .legend-item {\n    font-size: 0.95rem;\n    color: var(--clr-grey-1);\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n  }\n  \n  .legend-label {\n    color: var(--clr-grey-1);\n    font-weight: bold;\n    font-size: 1rem;\n    background-color: var(--clr-white);\n    padding: 0.2rem 0.6rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n  }\n  \n  .mandatory-asterisk {\n    color: red;\n    margin-left: 4px;\n  }\n  \n  .legend-horizontal-box {\n    border: 1px solid var(--clr-grey-3);\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    background-color: var(--red-light);\n    display: inline-block;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
